import React from 'react';
import { ModalOverlayProps, Modal as RACModal } from 'react-aria-components';

import './modal.global.scss';

export function Modal(props: ModalOverlayProps) {
  return <RACModal {...props} />;
}
